import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NotificationService } from '../../../services/notification.service';
import { finalize } from 'rxjs/operators';
import { PriorityViewModel } from 'app/models/PriorityViewModel';
import { NotificationDefinition } from '../../../shared/models/notifications/notifications';
import { PartnerService } from '../../../services/partner.service';
import { forkJoin } from 'rxjs';
import { PartnerNotificationSettingsComponent } from '../partner-notification-settings/partner-notification-settings.component';
import { PartnerOptionService } from '../../../services/partner-option.service';
import { PartnerOption } from '../../../shared/models/options/partner-option.model';
import { TabPanelDisplayMode } from 'app/components/enums/TabPanelDisplayMode';


@Component({
  selector: 'app-components-manager-partner-emails',
  templateUrl: './partner-emails.component.html'
})
export class PartnerEmailsComponent implements OnInit {
  @Input() partnerMinimal: Boo.Objects.PartnerMinimal;
  notificationDefinitions: NotificationDefinition[] = [];
  dfd: any;
  isLoading = false;
  tabPanelDisplayMode = TabPanelDisplayMode;
  partner: Boo.Objects.Partner;
  options: PartnerOption<any>[];
  @ViewChild(PartnerNotificationSettingsComponent) emailSettingsComponentRef: PartnerNotificationSettingsComponent;

  constructor(
    private notificationService: NotificationService,
    private partnerService: PartnerService,
    private partnerOptionService: PartnerOptionService) { }

  ngOnInit(): void {
    this.isLoading = true;
    forkJoin([
      this.notificationService.getPartnerDefinitions(this.partnerMinimal.PartnerId),
      this.partnerService.get(this.partnerMinimal.PartnerId),
      this.partnerOptionService.getAll(this.partnerMinimal.PartnerId)
    ])
      .pipe(finalize(() => this.isLoading = false))
      .subscribe(
        ([notificationDefinitions, partner, options]) => {
          this.notificationDefinitions = notificationDefinitions;
          this.partner = partner;
          this.options = options;
        },
        err => toastr.error(err)
      );
  }

  close(): void {
    if (this.dfd) {
      this.dfd.resolve();
    }
  }

  save(): void {
    if (!this.emailSettingsComponentRef.notificationSettingsForm.valid) {
      toastr.error("Fix the errors on the page before saving");
      return;
    }

    this.isLoading = true;
    forkJoin([
      this.emailSettingsComponentRef.frontChannelComponentRef.save(this.partnerMinimal.PartnerId),
      this.partnerService.update(this.partner, false, null),
      this.notificationService.updatePartnerExclusions(this.partner.PartnerId, this.notificationDefinitions),
      this.partnerOptionService.save(this.options)
    ])
      .pipe(finalize(() => this.isLoading = false))
      .subscribe({
        next: () => {
          toastr.success('Settings updated successfully');
          this.close();
        },
        error: err => toastr.error(err)
      });
  }

  openTemplates(definition: NotificationDefinition): void {
    PriorityViewModel.ngShow('app-notification-definition', { definition: definition, partnerId: this.partner.PartnerId });
  }

}
